/* eslint-disable react/display-name */
import { useQuery } from '@apollo/client';
import { GetTagsQuery, GetTagsQueryVariables, TagType } from 'lib/generated/graphql';
import { GET_TAGS } from 'lib/queries';
import { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import Error from 'src/shared-components/Form/Error';
import TagsSelector from 'src/shared-components/TagsSelector';

const FormTags = forwardRef(
  (
    {
      selectedIds = [],
      onFormSubmitted,
      type,
    }: { selectedIds?: number[]; onFormSubmitted: (values: number[]) => void; type: 'CREATOR' | 'COMPANY' },
    ref,
  ) => {
    const [selectedTags, setSelectedTags] = useState<any>(selectedIds);
    const { error, data } = useQuery<GetTagsQuery, GetTagsQueryVariables>(GET_TAGS, {
      variables: { where: { type: { equals: type as TagType } } },
    });
    const [formError, setFormError] = useState<string>();

    useImperativeHandle(ref, () => ({
      submitForm() {
        if (selectedTags.length === 0) {
          setFormError('Select at least one tag');
          return;
        }
        onFormSubmitted(selectedTags);
      },
    }));

    useEffect(() => {
      if (selectedTags.length > 0) {
        setFormError('');
      }
    }, [selectedTags]);

    if (!data) return null;

    if (error) {
      // TODO: show error to the user
      /* istanbul ignore next */
      console.error(error);
    }

    return (
      <div data-testid="formTags">
        <TagsSelector tags={data.findTags} onChange={setSelectedTags} initialValues={selectedIds} />
        {formError && <Error error={formError} />}
      </div>
    );
  },
);

export default FormTags;
